import type { Absence, AbsenceCategory, PendingAbsence } from '@/domain/types'
import { useApiQuery, type QueryState } from '@/api/useApiQuery'
import { useApiAction, type UseApiActionResult } from '@/api/useApiAction'

/**
 * Absence requests and decisions (adr/008 §3), served by
 * api/src/routes/absences.ts. Whether a request lands Pending or Approved is the
 * server's call, so the SPA sends what was asked and renders what came back.
 */

export function useAbsenceCategories(): QueryState<AbsenceCategory[]> {
  return useApiQuery<AbsenceCategory[]>('/api/absence-categories')
}

/** Requests the signed-in person may decide. Empty for anyone who manages nobody. */
export function usePendingAbsences(refreshKey = 0): QueryState<PendingAbsence[]> {
  return useApiQuery<PendingAbsence[]>('/api/absences/pending', refreshKey)
}

/** How many of those there are, for the My work badge, without loading what each would hit. */
export function usePendingCount(refreshKey = 0): QueryState<{ count: number }> {
  return useApiQuery<{ count: number }>('/api/absences/pending/count', refreshKey)
}

/** POST /api/absences and POST /api/absences/:id/decision. */
export function useAbsenceAction(): UseApiActionResult<Absence> {
  return useApiAction<Absence>()
}
